/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsflagunconfirmed2Inputs */

const en_signupsflagunconfirmed2 = /** @type {(inputs: Signupsflagunconfirmed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email unconfirmed`)
};

const de_signupsflagunconfirmed2 = /** @type {(inputs: Signupsflagunconfirmed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail unbestätigt`)
};

/**
* | output |
* | --- |
* | "Email unconfirmed" |
*
* @param {Signupsflagunconfirmed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsflagunconfirmed2 = /** @type {((inputs?: Signupsflagunconfirmed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsflagunconfirmed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsflagunconfirmed2(inputs)
	return de_signupsflagunconfirmed2(inputs)
});
export { signupsflagunconfirmed2 as "signupsFlagUnconfirmed" }